<template>
 <v-container mt-0>
  
  <v-layout row>
<v-flex xs12 sm4 ><span style="font-size:20px">Screen Output</span>
<v-btn v-if="status.ftb=='True'" color="red" @click="sendCommand(ftbBtn)">
      <v-icon dark left>{{'tv_off'}}</v-icon>
     {{ 'OFF' }}
    </v-btn>
    <v-btn v-if="status.ftb!='True'" color="green" @click="sendCommand(ftbBtn)">
      <v-icon dark left>{{'tv'}}</v-icon>
     {{ 'ON' }}
    </v-btn>
    <v-btn  v-if="status.muted=='True'" color="red" @click="sendCommand(muteBtn)">
      <v-icon dark left>volume_mute</v-icon>
     {{ 'OFF' }}
    </v-btn>
    <v-btn  v-if="status.muted!='True'" color="green" @click="sendCommand(muteBtn)">
      <v-icon dark left>volume_up</v-icon>
     {{ 'ON' }}
    </v-btn>
    version:{{version}}
    </v-flex>
    <v-flex xs12 sm7 pt-2>
    <span style="font-size:20px">Volume: {{deviceVolume}}</span>
    
         <!--<v-slider style="display:inline-block;"
          v-model="volume"
          
          label="Volume"
          
          thumb-label="always"
        ></v-slider>&nbsp;&nbsp;{{deviceVolume}} -->
        <v-btn @click="volumeDown()"><v-icon dark left>volume_down</v-icon>-</v-btn>
       <v-btn @click="volumeUp()"><v-icon dark left>volume_up</v-icon>+</v-btn>
   
    </v-flex>
     </v-layout>
  <v-layout row>
   <v-flex xs12  >

          <v-text-field
            label="Heading" v-model="heading"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6  ml-4>
         <v-text-field v-model="description"
            label="Description"
          ></v-text-field>
           
        </v-flex>
        <v-btn @click="sendMessage">Send</v-btn>
     </v-layout>
    <v-layout>
    <v-flex>
    <div  v-for="control in controls" :key="control.id" style="display:inline-block">
    <v-btn color="primary" @click="sendCommand(control)">
      <v-icon dark left>{{control.icon}}</v-icon>
     {{ control.label}}<v-text-field v-if="control.param" v-model="control.param" class="buttonInput"
            label="Solo"
            solo
          ></v-text-field>
    </v-btn>
    {{control.title}}
    </div>
    </v-flex>
    </v-layout>
    <v-layout row>
     <v-btn @click="downloadFiles">Download Files</v-btn>
      <v-btn @click="openPlaylist">Open Preset</v-btn>
      <v-btn @click="startPlaylist">Start Playlist</v-btn>
      <v-btn @click="stopPlaylist">Stop Playlist</v-btn>
    </v-layout>
    <v-layout row>
       <v-btn @click="getInfo">Get Info</v-btn>
        <v-btn @click="refresh">Refresh</v-btn>
    </v-layout>
    <v-layout >
    <v-flex >
      <div  >
    <v-btn  v-if="status" v-for="btn in  mediaBtns" :key="btn.id"
        color="primary" @click="preview(btn)"  
       :class="{active:status.active==btn.label, preview:status.preview==btn.label}" >
    
     {{btnText(btn)}}
      <img v-if="btn.image" :src="btn.image" height="35px">
    </v-btn>
    
     </div>
     </v-flex>
    </v-layout>
     <v-layout >
    <v-flex >
    <v-btn v-for="sch in  scheduals" :key="sch.id" @click="openPreset(sch)">
     {{sch.title}} 
    </v-btn>
    
     
    </v-flex>
    </v-layout>
    <div v-if="status">{{status.active}}<br>{{status.message}}</div>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      //volume:75,
      deviceVolume:75,
      heading:'',
      description:'',
      duration:1000,
      ftbBtn:{cmd:"ftb"},
      muteBtn:{cmd:"volumeOnOff"},
      controls:[{label:"Cut",cmd:"cut",icon:"blur_off"},
                {label:"Fade",cmd:"fade",icon:"blur_on",paramname:"duration",param:1000},
                {label:"FTB",cmd:"showBlack",icon:"label_important"}],
      email: '',
      password: '',
      confirmPassword: '',
      version:"0.20"
    }
  },
  created() {
      console.log( this.scheduals)
      this.$store.dispatch('loadControls');
      if(this.mediaList && this.mediaList.length==0){
        this.$store.dispatch('loadContents'); 
      }
      console.log("XXXX STATUS", this.status)
      if(this.status){
        if(this.status.deviceVolume){
          this.deviceVolume=parseFloat(this.status.deviceVolume);
        }
      }
  },
  
  computed: {
    
    tracks () {
       return this.$store.getters.getTracks
     },
     status () {
       //return false;
       return this.$store.getters.getStatus
     },
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    },
    scheduals(){
      
      return this.$store.getters.loadedSchedules
    },
    mediaBtns(){
      console.log("BTNS")
      var btns=[];
      var mediaObj={};
      var tracks=this.tracks.tracks;
      var callBtn=null
      var callBack=null
      for(var i=0;i<tracks.length;i++){
      
        console.log(tracks[i]);
        var media=tracks[i].split(".")
        var id=media[0];
        console.log("---",id)
        if(id.indexOf("title")==0){
          mediaObj={text:"Title",index:(i+1),label:""+(i+1),cmd:"play",media:id};
        }else if(id.indexOf("Browser")==0){
          mediaObj={text:"URL",index:(i+1),label:""+(i+1),cmd:"play",media:id};
        }else if(id.indexOf("Dec")==0){
          mediaObj={text:"Camera",index:(i+1),label:""+(i+1),cmd:"play",media:id};
        }else if(id.indexOf("Colour")==0){
          mediaObj={text:"Blank",index:(i+1),label:""+(i+1),cmd:"play",media:id};
        }else if(id.indexOf("card")==0){
          mediaObj={text:"Card",index:(i+1),label:""+(i+1),cmd:"play",media:id};
        }else if(id.indexOf("Call")==0){
          mediaObj={text:"Video Call",index:(i+1),label:"",cmd:"play",media:id};
          callBtn ={text:"Call F",label:"",cmd:"call",media:id.substr(5)}
          callBack ={text:"Call B",label:"",cmd:"callBack",media:id.substr(5)}
        }else{
          mediaObj={index:(i+1),label:""+(i+1),cmd:"play",media:id};
        }
        if(media[1]=="mp4"){
          if(this.getContent(id)){
             mediaObj.image=this.getContent(id).imageUrl;
          }else{
              console.log("MISSING",id,this.getContent(id));
               mediaObj.image=null;
          }
         
         
        }
        btns.push(mediaObj);
        if(callBtn){
           btns.push(callBtn);
           callBtn=null;
        }
        if(callBack){
           btns.push(callBack);
           callBack=null;
        }
         
     }
     console.log(btns);
     return btns
    }
  },
  watch: {
    
    user (value) {
      
      console.log("HAVE A USER");
    },
    status (value) {
      
      console.log("HAVE status",value);
      if(value.deviceVolume){
        this.deviceVolume=parseFloat(value.deviceVolume).toFixed(1);
      }
    },
    tracks (value) {
      console.log("HAVE tracks",value);
      console.log(this.mediaBtns);
      /*this.mediaBtns=[];
      var mediaObj={};
      for(var i=0;i<value.tracks.length;i++){
      
        console.log(value.tracks[i]);
        var media=value.tracks[i].split(".")
        var id=media[0];
          mediaObj={label:""+(i+1),cmd:"play",media:id};
        if(media[1]=="mp4"){
          console.log(this.getContent(id));
          mediaObj.image=this.getContent(id).imageUrl;
        }
         this.mediaBtns.push(mediaObj);
         
     }
     */
    }
  },
  methods: {
    volumeUp(){
      this.$store.dispatch('sendCommand', {cmd:'volumeUp'});
    },
    volumeDown(){
      //this.$store.dispatch('setControlsVolume', 90);
      this.$store.dispatch('sendCommand', {cmd:'volumeDown'});


    },
    btnText(btn){
      if(btn.text=="Call F" || btn.text=="Call B"){
        return btn.text
      }
        if(btn.media.indexOf("-")!=0){
          if(btn.media.indexOf("Browser")==0){
            return (btn.media.substr(8))
          }
          return (btn.media)
        }
        if(btn.label && btn.text){
          return (btn.label +" "+btn.text)
        }
        if(btn.text){
          return (btn.text)
        }
         
        if(btn.label){
          return (btn.label)
        }

        return null
    },
    sendMessage (btn) {
      this.$store.dispatch('sendMessage',{heading: this.heading,description: this.description})
      console.log(this.heading)
    },
    sendCommand (btn) {
     
      this.$store.dispatch('sendCommand',btn)
      console.log(btn)
     
    },
    
    play(btn){
      this.$store.dispatch('setControlsPlay',btn);
    },
    preview(btn){
       if(btn.cmd=="call"){
       window.open('https://www.vmixcall.com/call.aspx?Key='+btn.media+'&Name='+btn.media, '_blank');
      }else if(btn.cmd=="callBack"){
       window.open('https://www.vmixcall.com/call.aspx?Key='+btn.media+'&Name='+btn.media+'&Camera=Back', '_blank');
      }else{
       this.$store.dispatch('setControlsPreview',btn);
      console.log(btn)
      }
     
    },
    generatePlaylist(){
      console.log("Make the list")
      this.$store.dispatch('sendCommand',{cmd:"generate"});
    },
    downloadFiles(){
      console.log("Download Files")
      this.$store.dispatch('sendCommand',{cmd:"download"});
    },
    openPreset(sch){
      console.log("OPEN SCH",sch);
       this.$store.dispatch('setControlsOpen', sch);
    },
    openPlaylist(){
      console.log("Make the list")
      this.$store.dispatch('sendCommand',{cmd:"open"});
    },
    startPlaylist(){
      console.log("Make the list")
      this.$store.dispatch('sendCommand',{cmd:"start"});
    },
    stopPlaylist(){
      console.log("Make the list")
      this.$store.dispatch('sendCommand',{cmd:"stop"});
    },
    getInfo(){
      console.log("Get Info")
      this.$store.dispatch('sendCommand',{cmd:"info"});
    },
    refresh(){
      this.$store.dispatch('sendCommand',{cmd:"refresh"});
    },
    onSignin () {
      console.log('email:', this.email)
      this.$store.dispatch('signUserIn', {email: this.email, password: this.password})
    },
    onDismissed () {
      console.log('Dismissed alert')
      this.$store.dispatch('clearError')
    },
    getContent(id){
      return this.$store.getters.loadedContent(id)
    },
  }
}
</script>
<style>
.v-text-field.v-text-field--solo .v-input__control{
    min-height: 26px;
    height: 26px;
    padding:0px 16pX;
    width: 100px;
}
.v-btn__content {
  height: 30px;
}
.buttonInput.input-group.input-group--solo {
    margin-left: 10px;
   
}
.buttonInput.input-group.input-group--solo label {
    top: 2px;
}
.buttonInput.input-group.input-group--solo {
    min-height: 26px; 
}
.buttonInput.input-group.input-group--solo .input-group__input{
  padding:0px 16px;
   width:80px;
}
.v-btn.preview{
  background-color: orange!important;
}
.v-btn.active{
  background-color: green!important;
}
</style>


// WEBPACK FOOTER //
// src/components/Control/Controls.vue